import React from 'react';
import { Form, Input, Select, InputNumber, Divider, Space } from 'antd';
import {
  ExerciseMeasurementType,
  ExerciseMovementPattern,
  ExerciseType,
  FitCoachPrimaryArea,
} from '@wellverse/shared-ts';

const enumOptions = (e: Record<string, string>) =>
  Object.values(e).map((v) => ({ label: v, value: v }));

/**
 * FitCoach classification fields shared by the exercise create/edit forms.
 * Optional fields — left blank they fall back to the DB/schema defaults.
 */
export const ExerciseClassificationFields: React.FC = () => (
  <>
    <Divider orientation="left" plain>
      FitCoach Classification
    </Divider>

    <Form.Item label="Exercise Type" name="exerciseType" initialValue={ExerciseType.STRENGTH}>
      <Select placeholder="Select type" allowClear>
        {enumOptions(ExerciseType).map((o) => (
          <Select.Option key={o.value} value={o.value}>{o.label}</Select.Option>
        ))}
      </Select>
    </Form.Item>
    <Form.Item label="Movement Pattern" name="movementPattern">
      <Select placeholder="Select movement pattern" allowClear>
        {enumOptions(ExerciseMovementPattern).map((o) => (
          <Select.Option key={o.value} value={o.value}>{o.label}</Select.Option>
        ))}
      </Select>
    </Form.Item>
    <Form.Item label="Measurement Type" name="measurementType" initialValue={ExerciseMeasurementType.REPS}>
      <Select placeholder="Select measurement type" allowClear>
        {enumOptions(ExerciseMeasurementType).map((o) => (
          <Select.Option key={o.value} value={o.value}>{o.label}</Select.Option>
        ))}
      </Select>
    </Form.Item>
    <Form.Item label="Primary Area" name="primaryArea" initialValue={FitCoachPrimaryArea.FULL_BODY}>
      <Select placeholder="Select primary area" allowClear>
        {enumOptions(FitCoachPrimaryArea).map((o) => (
          <Select.Option key={o.value} value={o.value}>{o.label}</Select.Option>
        ))}
      </Select>
    </Form.Item>
    <Form.Item label="Secondary Areas (informational only)" name="secondaryAreas">
      <Select mode="multiple" placeholder="Select secondary areas" allowClear>
        {enumOptions(FitCoachPrimaryArea).map((o) => (
          <Select.Option key={o.value} value={o.value}>{o.label}</Select.Option>
        ))}
      </Select>
    </Form.Item>

    <Form.Item label="Rep Range (reps exercises)" style={{ marginBottom: 0 }}>
      <Space.Compact>
        <Form.Item name="repRangeMin" noStyle>
          <InputNumber min={0} placeholder="Min" style={{ width: 120 }} />
        </Form.Item>
        <Input placeholder="–" disabled style={{ width: 30, borderLeft: 0, borderRight: 0, pointerEvents: 'none', textAlign: 'center' }} />
        <Form.Item name="repRangeMax" noStyle>
          <InputNumber min={0} placeholder="Max" style={{ width: 120 }} />
        </Form.Item>
      </Space.Compact>
    </Form.Item>
    <Form.Item label="Duration Range in seconds (hold/cardio)" style={{ marginTop: 8, marginBottom: 0 }}>
      <Space.Compact>
        <Form.Item name="durationRangeMinSec" noStyle>
          <InputNumber min={0} placeholder="Min" style={{ width: 120 }} />
        </Form.Item>
        <Input placeholder="–" disabled style={{ width: 30, borderLeft: 0, borderRight: 0, pointerEvents: 'none', textAlign: 'center' }} />
        <Form.Item name="durationRangeMaxSec" noStyle>
          <InputNumber min={0} placeholder="Max" style={{ width: 120 }} />
        </Form.Item>
      </Space.Compact>
    </Form.Item>

    <Form.Item label="Requires Space (cardio only)" name="requiresSpace" style={{ marginTop: 8 }}>
      <Select placeholder="stationary / locomotion" allowClear>
        <Select.Option value="stationary">stationary</Select.Option>
        <Select.Option value="locomotion">locomotion</Select.Option>
      </Select>
    </Form.Item>
    <Form.Item label="Speed Range km/h (machine cardio)" style={{ marginBottom: 0 }}>
      <Space.Compact>
        <Form.Item name="speedRangeMin" noStyle>
          <InputNumber min={0} step={0.1} placeholder="Min" style={{ width: 120 }} />
        </Form.Item>
        <Input placeholder="–" disabled style={{ width: 30, borderLeft: 0, borderRight: 0, pointerEvents: 'none', textAlign: 'center' }} />
        <Form.Item name="speedRangeMax" noStyle>
          <InputNumber min={0} step={0.1} placeholder="Max" style={{ width: 120 }} />
        </Form.Item>
      </Space.Compact>
    </Form.Item>
    <Form.Item label="Equipment Needed (slug)" name="equipmentNeeded" style={{ marginTop: 8 }}>
      <Input placeholder="dumbbell / machine / foam_roller… (blank = bodyweight-style)" />
    </Form.Item>
    <Form.Item label="External ID (xlsx slug)" name="externalId">
      <Input placeholder="chest_pushup" />
    </Form.Item>
    <Form.Item label="Notes (single-language hint)" name="notes">
      <Input.TextArea rows={2} placeholder="每側 / 手撐高台,較易 …" />
    </Form.Item>
  </>
);
